"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "Procurar",
  Change: "Alterar",
  "Drop your image here": "Solte sua imagem aqui",
  "Drop your logo here": "Solte seu logotipo aqui",
  Remove: "Remover",
  "Revert to default": "Voltar para o padrão",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ['O arquivo "', ["fileName"], '" é maior que ', ["maxFileSize"], ", e não é possível carregá-lo. Carregue um arquivo de até ", ["maxFileSize"], "."],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ['O arquivo "', ["fileName"], '" é menor que ', ["minFileSize"], ", e não é possível carregá-lo. Carregue um arquivo de no mínimo ", ["minFileSize"], "."],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["Este formato de imagem não é compatível. Insira um ", ["fileTypes"], "."],
  "Unsupported file type": "Tipo de arquivo incompatível"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map